<template>
  <section class="l-auth">
    <div class="l-auth__page">
      <header></header>
      <main class="l-auth__content">
        <slot />
      </main>
      <auth-footer />
    </div>
  </section>
</template>
<script>
import AuthFooter from "@/components/Footer/Footer";
export default {
  data() {
    return {};
  },
  components: {
    AuthFooter
  }
};
</script>
<style lang="scss">
@import "~@/assets/scss/_variables.scss";
.l-auth {
  background-image: linear-gradient(
    to top,
    rgba(255, 255, 255, 0),
    #{$white-two}
  );
  width: 100%;

  &__page {
    min-height: 100vh;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-size: cover;
    background-position: bottom center;
    background-repeat: no-repeat;
  }

  header,
  &__content,
  auth-footer {
    width: 100%;
  }

  &__content {
    max-width: 564px;
    margin: 0 auto;
  }

  @media (min-width: 1920px) {
    &__page {
      background-image: url(~@/assets/img/auth-bg-box.jpg);
    }
  }

  @media (max-width: 1920px) {
    &__page {
      background-image: url(~@/assets/img/auth-bg-box-fullhd.jpg);
    }
  }
}
</style>
